import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import PageHero from "../components/shared/PageHero";
import { Home, ArrowRight } from "lucide-react";

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col bg-white">
      <PageHero
        title="Page Not Found"
        description="The page you are looking for does not exist or has been moved."
        breadcrumbs={[{ label: '404 Error', href: '#' }]}
        variant="light"
      />
      
      <section className="py-24 md:py-32 bg-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-[0.03] pointer-events-none">
           <img src="/images/campus/building-01.jpg" alt="Background" className="w-full h-full object-cover grayscale" />
        </div>
        
        <div className="max-w-7xl mx-auto px-6 text-center relative z-10 space-y-12">
          <div className="space-y-4">
            <h1 className="text-9xl font-black text-navy uppercase tracking-tighter italic animate-bounce leading-none">404</h1>
            <div className="w-24 h-1 bg-gold mx-auto"></div>
          </div>
          
          <div className="space-y-6">
            <h2 className="text-3xl font-black text-navy uppercase tracking-tighter italic">Oops! Something went wrong.</h2>
            <p className="text-xl text-gray-500 max-w-lg mx-auto font-medium">
              We couldn't find the page you were looking for. It might have been moved or deleted.
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-6">
            <Link
              to="/"
              className="bg-navy text-white px-12 py-5 font-black uppercase tracking-widest text-xs shadow-xl hover:bg-gold hover:text-navy transition-all active:scale-95 flex items-center gap-3"
            >
              <Home className="w-4 h-4" /> {t("Return to Home")}
            </Link>
            <Link
              to="/contact"
              className="border-2 border-navy text-navy px-12 py-5 font-black uppercase tracking-widest text-xs hover:bg-navy hover:text-white transition-all active:scale-95 flex items-center gap-3"
            >
              Contact Support <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
